import Checkbox from '@/components/UI/Form/Checkbox';

export default function TableHead({
  headers,
  handleBulkSelected,
  isBulkSelected,
}: {
  headers: string[];
  handleBulkSelected?: (selected: boolean) => void;
  isBulkSelected?: boolean;
}) {
  return (
    <thead className='bg-gray-50 border-primaryColor-normal border-l-4'>
      <tr>
        {handleBulkSelected && (
          <th className='pl-4'>
            <Checkbox
              name='departmentLedProject'
              id='department-led-project'
              checked={isBulkSelected}
              onChange={(e) => {
                handleBulkSelected(e.target.checked);
              }}
              onClick={(e) => {
                e.stopPropagation();
              }}
            />
          </th>
        )}
        {headers.map((th) => (
          <th key={th} scope='col' className='p-6 text-left text-xs font-bold text-gray-500 capitalize tracking-wider'>
            {th}
          </th>
        ))}
      </tr>
    </thead>
  );
}
